import React, { useState, useEffect } from "react";

const RightContentActionPermissions = ({
  selectedOption,
  permissionByModule,
  sendDataToParent,
}) => {
  const [checkboxes, setCheckboxes] = useState();
  const [modulePermission, setModulePermission] = useState(permissionByModule);

  let checkedPermissionIds = [];

  useEffect(() => {
    setModulePermission(permissionByModule);
  }, [permissionByModule]);

  useEffect(() => {
    if (selectedOption !== undefined && modulePermission) {
      setCheckboxes(modulePermission[selectedOption]);
    }
  }, [selectedOption, modulePermission]);

  const handleCheckboxChange = (option, id) => {
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [option]: {
        id: id,
        ischecked: !prevCheckboxes[option].ischecked,
      },
    }));

    if (id !== undefined && !checkedPermissionIds.includes(id)) {
      checkedPermissionIds.push(id);
    }
    sendDataToParent(checkedPermissionIds);
  };

  return (
    <div className="right-content">
      <h4>{selectedOption}</h4>
      <div className="checkboxes row">
        {checkboxes &&
          Object.keys(checkboxes).map((option) => {
            return (
              <div key={"p-" + option} className="col-4">
                <div key={option} className="checkbox-item">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      className="checkbox-name"
                      type="checkbox"
                      id={checkboxes[option].id}
                      checked={checkboxes[option].ischecked}
                      onChange={() =>
                        handleCheckboxChange(option, checkboxes[option].id)
                      }
                    />
                    <label className="label" htmlFor={option}>
                      {option.charAt(0).toUpperCase() + option.slice(1)}{" "}
                    </label>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
export default RightContentActionPermissions;
